let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLDsT")).then(() => parcelRequire('10Q59'));